import React, {useContext, useMemo, useState} from "react";
import Api from "../../../Api";
import {withAuth} from "../../../hoc/Auth";
import {Column, Container, Wrapper} from "../../../hoc/Layout";
import {
    InputHelper,
    Select,
    InputAmountCurrencyHelper, CardNumberInputHelper
} from "../../../Components/Utils/FieldsHelper";
import SingleDatePicker from "../../../Components/Utils/SingleDatePicker";
import EmptyCard from "../../../hoc/EmptyCard";
import Button from "../../../Components/Utils/UI/Button";
import MessageContext from "../../../MessageContext";
import { useParams, useHistory } from "react-router-dom";
import { useEffect } from "react";
import classes from "./styles.module.css";
import Uuid from "../../../Components/Utils/Uuid";

function PcaDuplicate({token}) {
    const psaID = useParams().ID
    const history = useHistory()
    const [contract, setContract] = useState(null)
    const [terminals, setTerminals] = useState([])
    const [uuid] = useState(Uuid.v4())
    const [psa, setPsa] = useState(null)

    const {onMessage} = useContext(MessageContext);
    const [form, setForm] = useState({
        docPcaName: "",
        docPcaDate: "",
        metalType: "",
        description: "",
        source: "",
        transport: "",
        pan: "",
        //comment: "",
        providerId: "",
        cardHolder: "",
    });

    const [viewMode, setViewMode] = useState(false)
    const [isRequest, setIsRequest] = useState(false);
    const [isTerminalsLoading, setIsTerminalsLoading] = useState(false);

    const [tableRows, setTableRows] = useState([
        { type: "", weight: "", price: "", grossWeight: "", tareWeight: "", contamination: "" },
    ]);

    const amount = useMemo(() => tableRows.reduce((acc, curr) => acc += Number(curr.price) * Number(curr.weight), 0).toFixed(2), [tableRows])

    const metalTypeList = [
        {displayName: 'Чёрный', isEnabled: true, id: "0"},
        {displayName: 'Цветной', isEnabled: true, id: "1"}
    ];

    function handleChange(name, value) {
        setForm({...form, [name]: value});
    }

    const handleRowChange = (index, field, value) => {
        const updatedRows = [...tableRows];
        updatedRows[index][field] = value;
        setTableRows(updatedRows);
    };

    const handleFloatChange = (index, field, value) => {
        if (!value.match(/^\d+\.?(\d{1,3})?$/)) {
            return
        }
        const updatedRows = [...tableRows];
        updatedRows[index][field] = value;
        setTableRows(updatedRows);
    }

    const handlePriceChange = (index, field, value) => {
        if (!value.match(/^\d+\.?(\d{1,2})?$/)) {
            return
        }
        const updatedRows = [...tableRows];
        updatedRows[index][field] = value;
        setTableRows(updatedRows);
    }

    const addRow = () => {
        setTableRows([
            ...tableRows,
            { type: "", weight: "", price: "", grossWeight: "", tareWeight: "", contamination: "" },
        ]);
    };

    const removeRow = (index) => {
        const updatedRows = tableRows.filter((_, i) => i !== index);
        setTableRows(updatedRows);
    };

    function handleActivate() {

        if (!contract) {
            onMessage({type: "error", message: "Ошибка. Не удалось получись сведения о контракте. Попробуйте перезагрузить страницу."})
            return
        }

        setIsRequest(true);

        for (let key in form) {
            if (form[key] === null || form[key].length === 0) {
                onMessage({type: 'warning', message: 'Все поля обязательны к заполнению. Проверьте данные и повторите попытку.'});
                return setIsRequest(false);
            }
        }

        const formClone = {
            name: form.docPcaName,
            date: form.docPcaDate.toISOString().split('T')[0],
            pan: form.pan.trim().split(' ').join(''),
            cardHolder: form.cardHolder,
            positions: tableRows.map(row => (
                {
                    type: row.type,
                    weight: row.weight,
                    price: row.price,
                    grossWeight: row.grossWeight,
                    tareWeight: row.tareWeight,
                    contamination: row.contamination,
                }
            )),
            providerId: form.providerId.uuid,
            psaContractId: contract.id,
            type: form.metalType.id,
            description: form.description,
            source: form.source,
            vehicle: form.transport,
            uuid
        }

        new Api({token}).createPsa(formClone).then(r => {
            if (r.status === 200 || r.status === 201) {
                setViewMode(true)
                onMessage({type: 'success', message: 'ПСА успешно создан!'});
                history.replace(`/metal/pca/${r.data.data.id}`)
            } else {
                onMessage({type: "error", message: "Ошибка. В форме пристутствуют ошибки. Проверьте данные и попробуйте снова."})
            }
        }).finally(() => {
            setIsRequest(false);
        })
    }
    
    useEffect(() => {
        setIsRequest(true)
        setIsTerminalsLoading(true)
        new Api({token}).getProjects().then((data) => {
            const providers = []
            data.map(p => p.providers.map(t => providers.push(t)))
            setTerminals(providers)
            setIsTerminalsLoading(false)
        })
        new Api({token}).getPsa(psaID).then((data) => {
            const psa = data.data
            setPsa(psa)
            setForm(prev => ({
                ...prev,
                docPcaName: psa.name,
                docPcaDate: new Date(psa.date),
                metalType: metalTypeList.find(type => type.id === psa.type) || "",
                description: psa.description,
                source: psa.source,
                transport: psa.vehicle,
                amount: psa.amount,
                pan: psa.pan,
                //comment: "",
                providerId: "",
                cardHolder: psa.cardHolder,
            }))
            setTableRows(psa.positions)
            setIsRequest(false)
        })
    }, [])

    useEffect(() => {
        if (psa) {
            new Api({token}).getMetalContract(psa.psaContractId).then((data) => {
                setContract(data.data);
            })
        }
    }, [psa])

    useEffect(() => {
        if (psa) {
            setForm(prev => ({
                ...prev,
                providerId: terminals.find(terminal => terminal.uuid === psa.providerId)
            }))
        }
    }, [terminals, psa])

    return (
        <Wrapper>
            <Container style={{justifyContent: 'center'}}>
                <Column width={'100%'}>
                    <EmptyCard title={"FieldsHelper.label.pcaCreate"}>

                        <div className={classes.Content}>
                            <div className={classes.Column}>
                                <h3 className={classes.Title}>Номер и дата контракта</h3>
                                <p className={classes.Text}>Все поля обязательны к заполнению.</p>

                                <div className={classes.DoubleCell}>
                                    <div className={classes.InputWrap}>
                                        <InputHelper
                                            onChange={handleChange}
                                            value={contract ? contract.name : ''}
                                            placeholder={"SAMPLE_01"}
                                            fieldName={"name"}
                                            label={"FieldsHelper.label.ContractName"}
                                            changeRegexp={/[^A-Za-zА-Яа-я0-9\-\s"_№]+/g}
                                            blurRegexp={/^[A-Za-zА-Яа-я0-9\-\s"_№]/}
                                            changeMessage={"FieldsHelper.label.ContractName"}
                                            blurMessage={"FieldsHelper.label.ContractName"}
                                            isDisabled={true}
                                            isRequired
                                            autoComplete="off"
                                        />
                                    </div>

                                    <div className={classes.InputWrap}>
                                        <label className={classes.Label}>Дата контракта</label>

                                        <SingleDatePicker
                                            selected={contract ? new Date(contract.date) : ''}
                                            className={classes.Input}
                                            dateFormat="dd.MM.yyyy"
                                            placeholderText="00.00.0000"
                                            disabled={true}
                                        />
                                    </div>
                                </div>

                                <h3 className={classes.Title}>Номер и дата ПСА</h3>
                                <p className={classes.Text}>Все поля обязательны к заполнению.</p>

                                <div className={classes.DoubleCell}>
                                    <div className={classes.InputWrap}>
                                        <InputHelper
                                            onChange={handleChange}
                                            value={form.docPcaName}
                                            placeholder={"SAMPLE_PCA_01"}
                                            fieldName={"docPcaName"}
                                            label={"FieldsHelper.label.PcaName"}
                                            changeRegexp={/[^A-Za-zА-Яа-я0-9\-\s"_№]+/g}
                                            blurRegexp={/^[A-Za-zА-Яа-я0-9\-\s"_№]/}
                                            changeMessage={"FieldsHelper.label.PcaName"}
                                            blurMessage={"FieldsHelper.label.PcaName"}
                                            isDisabled={isRequest || viewMode}
                                            isRequired
                                            autoComplete="off"
                                        />
                                    </div>

                                    <div className={classes.InputWrap}>
                                        <label className={classes.Label}>Дата ПСА</label>

                                        <SingleDatePicker
                                            selected={form.docPcaDate}
                                            onChange={date => {
                                                setForm({...form, docPcaDate: date});
                                            }}
                                            className={classes.Input}
                                            dateFormat="dd.MM.yyyy"
                                            placeholderText="00.00.0000"
                                            disabled={isRequest || viewMode}
                                        />
                                    </div>
                                </div>

                                <h3 className={classes.Title}>Основные данные</h3>

                                <div className={classes.InputWrap}>
                                    <Select
                                        label={"FieldsHelper.label.PcaTypeMetal"}
                                        placeholder={"FieldsHelper.label.PcaTypeMetal"}
                                        values={metalTypeList}
                                        onChange={(value) => handleChange("metalType", value)}
                                        selectedValue={form.metalType}
                                        fieldName={"displayName"}
                                        fieldStatus={"isEnabled"}
                                        isLoading={isRequest || viewMode}
                                    />
                                </div>

                                <div className={classes.InputWrap}>
                                    <InputHelper
                                        onChange={handleChange}
                                        value={form.description}
                                        placeholder={"Описание лома и отходов"}
                                        fieldName={"description"}
                                        label={"FieldsHelper.label.pcaDescriptionMetal"}
                                        changeRegexp={/[^А-Яа-я\-\s".№]+/g}
                                        blurRegexp={/^[А-Яа-я\-\s".№]/}
                                        changeMessage={"FieldsHelper.error.onlyLatinIssued"}
                                        blurMessage={"FieldsHelper.error.checkIssued"}
                                        isDisabled={isRequest || viewMode}
                                        isRequired
                                        autoComplete="off"
                                    />
                                </div>

                                <div className={classes.InputWrap}>
                                    <InputHelper
                                        onChange={handleChange}
                                        value={form.source}
                                        placeholder={"Источник лома"}
                                        fieldName={"source"}
                                        label={"FieldsHelper.label.pcaSourceMetal"}
                                        changeRegexp={/[^А-Яа-я\-\s".№]+/g}
                                        blurRegexp={/^[А-Яа-я\-\s".№]/}
                                        changeMessage={"FieldsHelper.error.onlyLatinIssued"}
                                        blurMessage={"FieldsHelper.error.checkIssued"}
                                        isDisabled={isRequest || viewMode}
                                        isRequired
                                        autoComplete="off"
                                    />
                                </div>

                                <div className={classes.InputWrap}>
                                    <InputHelper
                                        onChange={handleChange}
                                        value={form.transport}
                                        placeholder={"Марка и номер ТС"}
                                        fieldName={"transport"}
                                        label={"FieldsHelper.label.pcaTransportMetal"}
                                        changeRegexp={/[^A-Za-zА-Яа-я0-9\-\s".№]+/g}
                                        blurRegexp={/^[A-Za-zА-Яа-я0-9\-\s".№]/}
                                        changeMessage={"FieldsHelper.error.onlyLatinIssued"}
                                        blurMessage={"FieldsHelper.error.checkIssued"}
                                        isDisabled={isRequest || viewMode}
                                        isRequired
                                        autoComplete="off"
                                    />
                                </div>

                            </div>

                            <div className={classes.Column}>
                                {/* <div className={classes.InputWrap}>
                                    <InputHelper
                                        onChange={handleChange}
                                        value={form.comment}
                                        placeholder={"Комментарий для ПСА"}
                                        fieldName={"comment"}
                                        label={"FieldsHelper.label.pcaComment"}
                                        changeRegexp={/[^A-Za-zА-Яа-я0-9\-\s".№]+/g}
                                        blurRegexp={/^[A-Za-zА-Яа-я0-9\-\s".№]/}
                                        changeMessage={"FieldsHelper.error.onlyLatinIssued"}
                                        blurMessage={"FieldsHelper.error.checkIssued"}
                                        isDisabled={isRequest || viewMode}
                                        isRequired
                                        autoComplete="off"
                                    />
                                </div> */}

                                <div className={classes.InputWrap}>
                                    <InputAmountCurrencyHelper
                                        value={amount}
                                        currency={["RUB"]}
                                        placeholder={"1960.20"}
                                        label={"FieldsHelper.label.amount"}
                                        changeMessage={"FieldsHelper.error.onlyNumbersAmount"}
                                        blurMessage={"FieldsHelper.error.checkAmount"}
                                        isDisabled={true}
                                        autoComplete="off"
                                    />
                                </div>

                                <div className={classes.InputWrap}>
                                    <CardNumberInputHelper
                                        onChange={handleChange}
                                        value={form.pan}
                                        placeholder={"0000 0000 0000 0000 000"}
                                        isDisabled={isRequest || viewMode}
                                    />
                                </div>

                                <div className={classes.InputWrap}>
                                    <InputHelper
                                        onChange={handleChange}
                                        value={form.cardHolder}
                                        placeholder={"IVAN IVANOV"}
                                        fieldName={"cardHolder"}
                                        label={"FieldsHelper.label.cardholder"}
                                        changeRegexp={/[^A-Za-z\s]+/g}
                                        blurRegexp={/([A-Z]+\s)+([A-Z]+)/ig}
                                        changeMessage={"FieldsHelper.error.onlyLatinCardholder"}
                                        blurMessage={"FieldsHelper.error.checkCardholderName"}
                                        isUppercase
                                        isDisabled={isRequest || viewMode}
                                        autoComplete="off"
                                    />
                                </div>

                                <div className={classes.InputWrap}>
                                    <Select
                                        label={"FieldsHelper.label.terminal"}
                                        placeholder={"FieldsHelper.label.selectTerminal"}
                                        values={terminals}
                                        onChange={(value) => handleChange("providerId", value)}
                                        selectedValue={form.providerId}
                                        fieldName={"displayName"}
                                        fieldStatus={"enabled"}
                                        isLoading={isTerminalsLoading || viewMode}
                                    />
                                </div>
                                <EmptyCard title={"FieldsHelper.label.pcaDescription"}>
                                    <button className={classes.AddRowButton} disabled={viewMode} onClick={addRow}>
                                        +
                                    </button>

                                    {tableRows.map((row, index) => (
                                        <div key={index} className={classes.TableRow}>
                                            <div className={classes.Row}>
                                                <div className={classes.InputWrap}>
                                                    <InputHelper
                                                        onChange={handleRowChange}
                                                        value={row.type}
                                                        placeholder={"Вид металла"}
                                                        fieldName={"type"}
                                                        label={"FieldsHelper.label.metalType"}
                                                        changeRegexp={/[^A-Za-zА-Яа-я]+/g}
                                                        blurRegexp={/^[A-ZА-Я][A-Za-zА-Яа-я]*/}
                                                        changeMessage={"FieldsHelper.error.onlyLettersMetalType"}
                                                        blurMessage={"FieldsHelper.error.onlyLettersMetalType"}
                                                        isDisabled={isRequest || viewMode}
                                                        isRequired={true}
                                                        autoComplete={"off"}
                                                        index={index}
                                                    />
                                                </div>
                                                <div className={classes.InputWrap}>
                                                    <InputHelper
                                                        onChange={handleFloatChange}
                                                        value={row.weight}
                                                        placeholder={"Вес (тн)"}
                                                        fieldName={"weight"}
                                                        label={"FieldsHelper.label.metalWeight"}
                                                        changeRegexp={/[^0-9./]+/g}
                                                        blurRegexp={/^\d+(\.\d{1,3})?$/}
                                                        changeMessage={"FieldsHelper.error.onlyNumbersMetalWeight"}
                                                        blurMessage={"FieldsHelper.error.onlyNumbersMetalWeight"}
                                                        isDisabled={isRequest || viewMode}
                                                        isRequired
                                                        autoComplete="off"
                                                        index={index}
                                                    />
                                                </div>
                                                <div className={classes.InputWrap}>
                                                    <InputHelper
                                                        onChange={handlePriceChange}
                                                        value={row.price}
                                                        placeholder={"Цена (руб)"}
                                                        fieldName={"price"}
                                                        label={"FieldsHelper.label.metalPrice"}
                                                        changeRegexp={/[^0-9.]+/g}
                                                        blurRegexp={/^\d+(\.\d{1,2})?$/}
                                                        changeMessage={"FieldsHelper.error.onlyNumbersMetalPrice"}
                                                        blurMessage={"FieldsHelper.error.onlyNumbersMetalPrice"}
                                                        isDisabled={isRequest || viewMode}
                                                        isRequired
                                                        autoComplete="off"
                                                        index={index}
                                                    />
                                                </div>
                                            </div>

                                            <div className={classes.Row}>
                                                <div className={classes.InputWrap}>
                                                    <InputHelper
                                                        onChange={handleFloatChange}
                                                        value={row.grossWeight}
                                                        placeholder={"Вес брутто (тн)"}
                                                        fieldName={"grossWeight"}
                                                        label={"FieldsHelper.label.metalGrossWeight"}
                                                        changeRegexp={/[^0-9.]+/g}
                                                        blurRegexp={/^\d+(\.\d{1,3})?$/}
                                                        changeMessage={"FieldsHelper.error.onlyNumbersMetalWeight"}
                                                        blurMessage={"FieldsHelper.error.onlyNumbersMetalWeight"}
                                                        isDisabled={isRequest || viewMode}
                                                        isRequired
                                                        autoComplete="off"
                                                        index={index}
                                                    />
                                                </div>
                                                <div className={classes.InputWrap}>
                                                    <InputHelper
                                                        onChange={handleFloatChange}
                                                        value={row.tareWeight}
                                                        placeholder={"Вес тары (тн)"}
                                                        fieldName={"tareWeight"}
                                                        label={"FieldsHelper.label.metalTareWeight"}
                                                        changeRegexp={/[^0-9.]+/g}
                                                        blurRegexp={/^\d+(\.\d{1,3})?$/}
                                                        changeMessage={"FieldsHelper.error.onlyNumbersMetalWeight"}
                                                        blurMessage={"FieldsHelper.error.onlyNumbersMetalWeight"}
                                                        isDisabled={isRequest || viewMode}
                                                        isRequired
                                                        autoComplete="off"
                                                        index={index}
                                                    />
                                                </div>
                                                <div className={classes.InputWrap}>
                                                    <InputHelper
                                                        onChange={handleRowChange}
                                                        value={row.contamination}
                                                        placeholder={"Засоренность (%)"}
                                                        fieldName={"contamination"}
                                                        label={"FieldsHelper.label.metalImpurity"}
                                                        changeRegexp={/[^0-9]+/g}
                                                        blurRegexp={/^[0-9]{3}/}
                                                        changeMessage={"FieldsHelper.error.onlyNumbersMetalImpurity"}
                                                        blurMessage={"FieldsHelper.error.onlyNumbersMetalImpurity"}
                                                        isDisabled={isRequest || viewMode}
                                                        isRequired
                                                        autoComplete="off"
                                                        index={index}
                                                    />
                                                </div>
                                            </div>

                                            <div className={classes.RemoveButton}>
                                                <button disabled={viewMode} onClick={() => removeRow(index)}>-</button>
                                            </div>
                                        </div>
                                    ))}
                                </EmptyCard>

                                <div className={classes.InputWrap}>
                                    <Button label={"FieldsHelper.label.pcaBtn"} color={"#4caf50"}
                                            onClick={handleActivate} icon={"checkmark"} isDisabled={viewMode}
                                            isLoading={isRequest}/>
                                </div>

                            </div>
                        </div>

                    </EmptyCard>
                </Column>
            </Container>
        </Wrapper>
    )
}

export default withAuth(PcaDuplicate);



// WEBPACK FOOTER //
// ./src/PagesOfUser/Metal/PcaDuplicate/index.js